import { Component, OnInit, Input, AfterContentInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService, ScreenService } from '@ibe/services/ui';
import { FlightDetailsComponent } from './flight-details.component';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as FlightResultActions from '@ibe/store/actions/flight-result.actions';
import { Flight } from '@ibe/models';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRASegment } from '@ibe.models/segment.indra.model.lib';

import { AIRPLANE_EQUIPMENT_WITH_LOGOS,
		EQUIPMENT_CODE_TRAIN,
		EQUIPMENT_CODE_BUS,
		AIR_LINE_CODE_TAP,
		AIR_LINE_NAME_TAP,
		CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER,
		SESSION_VAR_KEY_LANGUAGE,
		SESSION_VAR_KEY_MARKET,
		DEFAULT_LANGUAGE,
		DEFAULT_MARKET,
		SPECIAL_CASE_MARKET_LANGUAGE_MAP
		} from '@ibe.config';

@Component({
	selector: 'app-flight-details',
	templateUrl: './flight-details.indra.component.html',
	styleUrls: ['./flight-details.component.scss'],
	host: {
		class: 'app-flight-details'
	},
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class INDRAFlightDetailsComponent extends FlightDetailsComponent
	implements OnInit, AfterContentInit, OnDestroy {

	@Input()
	flight;
	@Input()
	summaryMode: false;
	@Input()
	changeMode?: boolean = false;
	@Input()
	hideLogo: false;
	@Input()
	index: number = 0;

	@Input()
	showAirplane: false;

	isAlive: boolean = true;
	isMobile: boolean = false;

	airLinesOperationCarrier: string[] = [];
	airLinesCarrier: string[] = [];
	busSegments: INDRASegment[] = [];
	flightNumbers: string[] = [];
	flightStops: INDRASegment[] = [];
	commercialStops: INDRASegment[] = [];
	allStops: INDRASegment[] = [];

	private flight_departure_time: string = '';
	private flight_arrival_time: string = '';
	private flight_arrival_other_day = 0;
	private flight_duration: string = '';
	private flight_arrival_airport: string = '';
	private flight_departure_airport: string = '';

	airlineLogo;
	airlineName;
	ariaLabelRoute;
	departureAirportName;
	arrivalAirportName;
	ariaLabelDurationStops;
	flightNumber;
	
	airplaneLogo = null;
	airplaneName = null;

	operatedBy;

	flightDetails;
	isMYBOrBookingFlow: boolean = false;
	showInfo: boolean = false;
	isAllTAPOperated: boolean = false;


	constructor(
		private store: Store<fromStore.State>,
		private sidebarService: SidebarService,
		private dateService: INDRADateService,
		private bookingService: INDRABookingService,
		private bookingSearchService: INDRABookingSearchService,
		private ibeAdminService: INDRAIbeAdminService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private screen: ScreenService,
		private router: Router) {
			
		super();
		this.screen.isMobile()
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isMobile = value;
			});
	}

	ngOnInit() { }

	ngAfterContentInit() {
		if (this.flight) {
			// logic added to be able to use this component in both booking, review page and MYB
			if (!this.router.url.includes('/review-your-trip') &&
				!this.router.url.includes('/my-booking/details') &&
				!this.router.url.includes('flight-details') &&
				!this.router.url.includes('time-to-think') &&
				!this.router.url.includes('/my-bookings/view') &&
				!this.router.url.includes('booking/payment')) {
				this.flightDetails = this.flight;
				this.isMYBOrBookingFlow = false;
			} else {
				if (this.router.url.includes('flight-details-refunds')) {
					this.flightDetails = this.flight;
					this.isMYBOrBookingFlow = false;
				} else {
					this.flightDetails = this.flight.details;
					this.isMYBOrBookingFlow = true;
				}
			}

			const segmentLength = this.flightDetails.listSegment.length;
			this.flight_departure_time = this.INDRA_printTime(this.flightDetails.listSegment[0].departureDate);
			this.flight_arrival_time = this.INDRA_printTime(this.flightDetails.listSegment[segmentLength - 1].arrivalDate);
			/*
			this.flight_arrival_airport =
				this.bookingService.INDRA_getLastSegmentFlightIgnoringTrain(this.flightDetails.listSegment)['arrivalAirport'];
			this.flight_departure_airport =
				this.bookingService.INDRA_getFirstSegmentFlightIgnoringTrain(this.flightDetails.listSegment)['departureAirport'];
			*/
			this.flight_arrival_airport = this.flightDetails.listSegment[segmentLength - 1].arrivalAirport;
			this.flight_departure_airport = this.flightDetails.listSegment[0].departureAirport;
			this.airlineName = this.flightDetails.listSegment[0].carrier == AIR_LINE_CODE_TAP ? AIR_LINE_NAME_TAP : null;

			if (this.flightDetails.isStopOver) {
				// Find stopover segment
				const stopOverSegments = this.flightDetails.listSegment.filter(segment => segment.stopover);

				const lastSegment = stopOverSegments[0];
				this.flight_arrival_other_day = this.INDRA_printArrivalOtherDay(
					this.flightDetails.listSegment[0].departureDate, lastSegment.arrivalDate);
			} else {
				this.flight_arrival_other_day = this.INDRA_printArrivalOtherDay(
					this.flightDetails.listSegment[0].departureDate, this.flightDetails.listSegment[segmentLength - 1].arrivalDate);
			}

			this.flight_duration = this.INDRA_getDuration();

			const operationCarrierList = [];
			let equipmentWithLogo = null;
			let haulType = null;
			this.flightDetails.listSegment.forEach(segment => {
				if (!this.airLinesOperationCarrier.includes(segment.operationCarrier)) {
					this.airLinesOperationCarrier.push(segment.operationCarrier);
				}
				if (!this.airLinesCarrier.includes(segment.carrier)) {
					this.airLinesCarrier.push(segment.carrier);
				}
				if (!this.flightNumbers.includes(segment.flightNumber)) {
					this.flightNumbers.push(segment.flightNumber);
				}
				// if (segment.stopTime > 0 && segment.stopTime <= 1440 && !segment.stopover) {
				if (segment.stopTime > 0 && !segment.stopover) {
					this.flightStops.push(segment);
					this.allStops.push(segment);
				} else if(segment.technicalStops != null){
					if (segment.technicalStops.length > 0){
						this.commercialStops.push(segment);
						this.allStops.push(segment);
					}	
				}
						

				if (!operationCarrierList.includes(segment.operationCarrier) &&
					segment.equipment !== EQUIPMENT_CODE_TRAIN &&
					segment.equipment !== EQUIPMENT_CODE_BUS) {
					operationCarrierList.push(segment.operationCarrier);
				}
				if (segment.equipment === EQUIPMENT_CODE_BUS) {
					this.busSegments.push(segment);
				}
			});
			
			const significantFlightSegment = this.bookingSearchService.INDRA_getTAPMostSignificantFlightSegment(this.flightDetails);
			if (significantFlightSegment) {
				if (AIRPLANE_EQUIPMENT_WITH_LOGOS.includes(significantFlightSegment.equipment)) {
					equipmentWithLogo = significantFlightSegment.equipment;
					haulType = significantFlightSegment.haul;
				}
			}
			
			const tapCarriers = this.airLinesOperationCarrier.filter(carrier => CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER.includes(carrier));
			this.isAllTAPOperated = (this.airLinesOperationCarrier.length ===  tapCarriers.length) ? true : false;
			this.airlineName = this.INDRA_getAirlineName();
			this.airlineLogo = this.INDRA_getAirlineLogo();
			this.ariaLabelRoute = this.INDRA_ariaLabelRoute();
			this.departureAirportName = this.INDRA_getDepartureAirportName();
			this.arrivalAirportName = this.INDRA_getArrivalAirportName();
			this.ariaLabelDurationStops = this.INDRA_ariaLabelDurationStops();
			this.flightNumber = this.INDRA_getFlightNumber();

			if (operationCarrierList.length > 0) {
				this.operatedBy = this.INDRA_buildOperatedBy(operationCarrierList);
			}
			if (equipmentWithLogo) {
				this.airplaneLogo = this.bookingSearchService.INDRA_getNEOEquipmentLogoName(equipmentWithLogo, haulType);
				this.airplaneName = equipmentWithLogo; 
			}

			this.showInfo = this.INDRA_setShowInfo();
		}
	}

	INDRA_printTime(time: string): string {
		return this.dateService.INDRA_formatDate(time, 'HH:mm');
	}

	INDRA_printArrivalOtherDay(departureTime: string, returnTime: string): number {
		return Math.floor(Math.abs(
			this.dateService.INDRA_computeDifferenceOfDatesWithoutTimeInDays(departureTime, returnTime)));
	}

	INDRA_getTranslationAsync(key: string): Observable<string> {
		return this.ibeAdminService.getTranslationValueAsync(key);
	}

	INDRA_getDuration(): string {

		let flightDuration = 0;
		if (this.isMYBOrBookingFlow) {
			const segments = this.flight.details.listSegment;
			// Direct flights
			if (segments.length === 1) {
				flightDuration = segments[0].duration;
			} else {
				segments.forEach(segment => {
					flightDuration += (segment.duration +
						(segment.stopTime > 0 && !segment.stopover ? segment.stopTime : 0));
				});
			}
		} else {
			flightDuration = this.flight.duration;
		}

		const time_diff = flightDuration;
		const minutes =
			time_diff % 60 < 10 ? '0' + (time_diff % 60) : time_diff % 60; // Overflow minutes
		const hours =
			Math.floor(time_diff / 60) === 0
				? '0' + Math.floor(time_diff / 60)
				: Math.floor(time_diff / 60);
		return hours + 'h ' + minutes + 'min';
	}

	INDRA_getAirlineName() {
		if (this.airLinesOperationCarrier.length > 1 && this.busSegments.length === 0) {
			return this.isAllTAPOperated ? 'TAP Air Portugal' : this.INDRA_getTextTranslation('bookingDetails.alt.multipleAirlines');
		} else if (this.airLinesOperationCarrier.length >= 1 && this.busSegments.length > 0) {
			return this.INDRA_getTextTranslation('bookingDetails.alt.airlinesAndBus');
		}
		else {
			if (this.flight.airLinesTranslation && this.flight.airLinesTranslation[this.airLinesOperationCarrier[0]]) {
				return this.flight.airLinesTranslation[this.airLinesOperationCarrier[0]].name;
			} else {
				const airlineName =
					this.bookingSearchService.INDRA_getFlightSearchAirplaneInfo(this.airLinesOperationCarrier[0]);
				return (airlineName ? airlineName.name : this.airLinesOperationCarrier[0]);
			}
		}
	}

	INDRA_getNumberOfAirlines() {
		return this.airLinesOperationCarrier.length;
	}

	INDRA_getAirlineLogo() {
		let airlineLogo;
		if (this.busSegments.length > 0) {
			return 'icons.svg#plane_related--plane_and_bus';
		} else {
			if (this.airLinesOperationCarrier.length > 1) {
				airlineLogo = this.isAllTAPOperated ? AIR_LINE_CODE_TAP : 'Multiple';
			} else {
				airlineLogo = this.airLinesOperationCarrier[0];
			}
			return this.bookingSearchService.INDRA_buildAirlineLogoName(airlineLogo);
		}
	}

	INDRA_ariaLabelRoute() {

		let departureLocationName = '';
		let arrivalLocationName = '';

		if (this.isMYBOrBookingFlow) {
			departureLocationName = this.flight.departureLocation.name;
			arrivalLocationName = this.flight.arrivalLocation.name;
		} else {
			departureLocationName = this.bookingSearchService.INDRA_getFlightSearchLocation(this.flight_departure_airport).name;
			arrivalLocationName = this.bookingSearchService.INDRA_getFlightSearchLocation(this.flight_arrival_airport).name;
		}

		let label = '';
		label +=
			this.INDRA_getTextTranslation('bookingDetails.aria.thisFlightDepartsAt') +
			this.INDRA_printDepartureTime() +
			this.INDRA_getTextTranslation('bookingDetails.aria.from') +
			departureLocationName;
		label += this.INDRA_getTextTranslation('bookingDetails.aria.andArrives');
		if (this.INDRA_isOnAnotherDay()) {
			if (this.INDRA_printFlightDays() === 1) {
				label += this.INDRA_getTextTranslation('bookingDetails.aria.nextDay');
			} else {
				label += this.INDRA_printFlightDays() + this.INDRA_getTextTranslation('bookingDetails.aria.daysLater');
			}
		}
		label +=
			this.INDRA_getTextTranslation('bookingDetails.aria.at') +
			this.INDRA_printArrivalTime() +
			this.INDRA_getTextTranslation('bookingDetails.aria.on') +
			arrivalLocationName;

		return label;
	}

	INDRA_printDepartureTime(): string {
		return this.flight_departure_time;
	}

	INDRA_printArrivalTime(): string {
		return this.flight_arrival_time;
	}

	INDRA_isOnAnotherDay(): boolean {
		// Check if arrival not on same day of departure (=1)
		return this.flight_arrival_other_day > 0;
	}

	INDRA_printFlightDays(): number {
		return this.flight_arrival_other_day;
	}

	INDRA_printDuration(): string {
		return this.flight_duration;
	}

	/**
	 * Returns name of arrow icon depending if is a direct flight or not
	 * @param {boolean} direct is direct flight or not
	 * @returns if is direct flight or not
	 */
	INDRA_printLegStops(): String {
		return this.flightStops.length === 0 ? 'direct' : 'layover';
	}

	/**
	 * Returns stops
	 * @returns stops object
	 */
	INDRA_getStops() {
		// return this.flight && this.flight.listSegment ? this.flight.listSegment : 0;
		return this.flightStops.length > 0 ? this.flightStops : 0;
	}

	INDRA_getCommercialStops() {
		// return this.flight && this.flight.listSegment ? this.flight.listSegment : 0;
		return this.commercialStops.length > 0 ? this.commercialStops : 0;
	}

	INDRA_getAllStops() {
		// return this.flight && this.flight.listSegment ? this.flight.listSegment : 0;
		return this.allStops.length > 0 ? this.allStops : 0;
	}

	INDRA_ariaLabelDurationStops() {
		let label = '';
		if (this.flightStops.length === 0) {
			label += this.INDRA_getTextTranslation('bookingDetails.aria.thisIsADirectFlight');
		} else {
			if (this.flightStops.length === 1) {
				label += this.INDRA_getTextTranslation('bookingDetails.aria.thisFlightHas') + this.flightStops.length + this.INDRA_getTextTranslation('bookingDetails.aria.stopCommaSingular'); // Singular
			} else {
				label += this.INDRA_getTextTranslation('bookingDetails.aria.thisFlightHas') + this.flightStops.length + this.INDRA_getTextTranslation('bookingDetails.aria.stopsCommaPlural'); // Plural
			}
		}
		label += this.INDRA_getTextTranslation('bookingDetails.aria.andHasTheTotalDurationOf') + this.INDRA_printDuration();
		return label;
	}

	INDRA_printStopsCount() {
		return this.flightStops.length;
	}

	INDRA_printStopsCountUnitKey() {
		if (this.flightStops.length === 0) {
			return 'bookingDetails.label.direct';
		} else {
			if (this.flightStops.length === 1) {
				return 'bookingDetails.label.stop'; // Singular
			} else {
				return 'bookingDetails.label.stops'; // Plural
			}
		}
	}

	INDRA_getFlightNumberLength() {
		return this.flightNumbers.length;
	}

	INDRA_getFlightNumber() {
		if (this.airLinesCarrier && this.airLinesCarrier.length > 0 && 
			this.flightNumbers && this.flightNumbers.length > 0 && this.flightNumbers[0] ) {
			return this.airLinesCarrier[0] + ' ' + this.flightNumbers[0].padStart(4, '0');
		}
	}

	INDRA_handleDetailsClick() {

		if (this.isMYBOrBookingFlow) {
			if (!this.changeMode) {
				// MYB flow or review booking flow
				this.sidebarService.openSidebar(['flight-details',
					{ flight: this.flight.details.assignedFlightId }]);
			} else {
				// change booking flow
				this.sidebarService.openSidebar(['flight-details',
					{ flight: this.flight.details.idFlight, mode: 'change', bound: this.flight.bound }]);
			}
		} else {
			// for booking search flow
			this.store.dispatch(new FlightResultActions.PutSelectedFlightAction(
				Object.assign(new Flight(null, null, null), this.flight)));

			this.sidebarService.openSidebar(['flight-details',
				{ flight: this.flight.listSegment[0].flightNumber, mode: 'search' }]);
		}
	}

	INDRA_getArrivalAirport() {
		return this.flight_arrival_airport;
	}

	INDRA_getDepartureAirport() {
		return this.flight_departure_airport;
	}

	INDRA_getArrivalAirportName() {
		let name: string = '';
		if (this.flight) {
			name = (this.isMYBOrBookingFlow) ? this.flight.arrivalLocation.name :
				this.bookingSearchService.INDRA_getFlightSearchLocation(this.flight.listSegment[this.flight.listSegment.length - 1].arrivalAirport).name;
			if (!name || name.length == 0) {
				name = this.INDRA_getArrivalAirport();
			}
		}
		return name;
	}

	INDRA_getDepartureAirportName() {
		let name: string = '';
		if (this.flight) {
			name = (this.isMYBOrBookingFlow) ? this.flight.departureLocation.name :
				this.bookingSearchService.INDRA_getFlightSearchLocation(this.flight.listSegment[0].departureAirport).name;
			if (!name || name.length == 0) {
				name = this.INDRA_getDepartureAirport();
			}
		}
		return name;
	}

	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_ariaLabelNumberDetails() {
		return this.INDRA_getTextTranslation('bookingDetails.aria.flightNumberIs') + this.flightNumber;
	}

	INDRA_ariaLabelDurationDetails() {
		return this.INDRA_getTextTranslation('bookingDetails.aria.flightNumberIs') + this.flightNumber + this.INDRA_getTextTranslation('bookingDetails.aria.openDialogWithMoreFlightDetails');
	}

	INDRA_ariaLabelOpenDialog() {
		return this.INDRA_getTextTranslation('bookingDetails.aria.openDialogFlight');
	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}

	get direct() {
		if (this.flight.numberOfFlights === 1) {
			return 'Direct';
		} else {
			return 'Connecting';
		}
	}

	INDRA_printAirplaneLogo() {
		return this.airplaneLogo ? 'sprite.svg#' + this.airplaneLogo : false;
	}

	INDRA_getAirplaneLogo() {
		return this.airplaneLogo;
	}

	INDRA_printAirplaneLabel() {
		return this.airplaneName;
	}

	INDRA_setShowInfo() {
		let showInfo = false;
		this.flightDetails.listSegment.forEach(segment => {
			if (segment.directFlightGovAlert) {
				showInfo = true;
			}
		});
		return showInfo;
	}

	INDRA_showInfo() {
		return this.showInfo;
	}

	INDRA_buildOperatedBy(carrierList: string[]) {
		let returnValue = null;
		if (this.busSegments.length > 0) {
			carrierList.push('Bus');
		}
		
		const carrierListLastIndex = carrierList.length - 1;
		carrierList.forEach((carrier, index) => {
			const carrierObj = this.bookingSearchService.INDRA_getFlightSearchAirplaneInfo(carrier);
			const carriername = carrierObj && carrierObj.name ? carrierObj.name : carrier;
			if (index == 0) {
				returnValue = carriername;
			} else if (index != carrierListLastIndex) {
				returnValue = returnValue + ', ' + carriername;
			} else {
				returnValue = returnValue + ' and ' + carriername;
			}
		});
		return returnValue;
	}

	INDRA_promoNotAvailable() {
		// note: TODO implement this with actual logic
		// if (this.airlineName) {
		// 	return this.airlineName.indexOf('TAP') < 0 && this.flight.listSegment && this.bookedTripDiscounts.length;
		// }
		return false;
	}

	INDRA_print(operator) {
		operator = operator.replace('and', this.INDRA_getTextTranslation('availability.flightsPage.text.and'));
		return operator;
	}
	
	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

}
